<cas-banner></cas-banner>
<div class="login-container">
    <div class="login-form"
         [ngClass]="{'desktop-view' : isDesktop()}">
        <img class="caslink-logo"
             src="./assets/caslink_logo.svg"
             alt="CASLink logo"/>
        <div class="login-form-container">
            <form [formGroup]="loginForm"
                  (ngSubmit)="onSubmit()">
                <div class="login-controls">
                    <button mat-raised-button
                            id="login-button"
                            type="submit"
                            color="accent">
                        <mat-icon>reset_tv</mat-icon>
                        Login
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="footer">{{copyright}}</div>
</div>
